var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "position-x": _vm.position.x,
        "position-y": _vm.position.y,
        "close-on-content-click": false,
        "nudge-width": 600,
        "offset-x": "",
      },
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-form",
        { ref: "form", staticStyle: { width: "100%" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "title py-1" },
                [
                  _c("div", [
                    _c("div", { staticClass: "pt-1" }, [
                      _vm._v(" " + _vm._s(_vm.type) + " stations"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "caption py-1" }, [
                      _vm._v(_vm._s(_vm.guidelineName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-text",
                {},
                [
                  _c("v-text-field", {
                    staticClass: "emphasize-clear",
                    attrs: {
                      loading: _vm.isSearching,
                      "prepend-inner-icon": "search",
                      clearable: "",
                      solo: "",
                      placeholder: "Search stations",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "default-border-bottom scroll-border-bottom" },
                [
                  _c(
                    "v-item-group",
                    {
                      attrs: { mandatory: "", "active-class": "white--text" },
                      model: {
                        value: _vm.filterToggle,
                        callback: function ($$v) {
                          _vm.filterToggle = $$v
                        },
                        expression: "filterToggle",
                      },
                    },
                    [
                      _c(
                        "v-subheader",
                        {
                          staticStyle: { display: "inline", cursor: "default" },
                        },
                        [_vm._v("Show:")]
                      ),
                      _vm._v(" "),
                      _c("v-item", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ active, toggle }) {
                              return _c(
                                "v-chip",
                                {
                                  staticClass: "clickable chipFilter",
                                  attrs: {
                                    small: "",
                                    color: active ? "primary" : "default",
                                    selected: active,
                                  },
                                  on: { click: toggle },
                                },
                                [_vm._v("Available")]
                              )
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("v-item", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ active, toggle }) {
                              return _c(
                                "v-chip",
                                {
                                  staticClass: "clickable chipFilter",
                                  attrs: {
                                    small: "",
                                    color: active ? "primary" : "default",
                                    selected: active,
                                  },
                                  on: { click: toggle },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pr-2",
                                      class: {
                                        "info--text font-weight-bold":
                                          _vm.formObject.stationIds.length > 0,
                                      },
                                      staticStyle: { float: "left" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.formObject.stationIds.length
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n              Selected\n            "
                                  ),
                                ]
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("SelectStations", {
                    ref: "selectStations",
                    attrs: {
                      search: _vm.search,
                      filterToggle: _vm.filterToggle,
                      filterToggles: _vm.filterToggles,
                      stations: _vm.stations,
                    },
                    on: {
                      isSearching: function ($event) {
                        _vm.issearching = $event
                      },
                      selected: _vm.onStationSelection,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", outline: "" },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Save")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }